module.exports = __webpack_public_path__ + "img/MejoraCareLogo.e046e7a1.svg";